import React, { useEffect } from "react";

import { getPersonal } from "@/components/profile/personalDetails/query";

const animateText = [
  "Analyzing your profile information",
  "AI is generating insights",
  "Fine-tuning your summary",
  "Hang On! Almost ready with your summaries",
  "Preparing to present your summaries",
  "Sending details to AI",
];
type LoadingSummaryProps = {
  isStartToFade: boolean;
};

const LoadingSummary = ({ isStartToFade }: LoadingSummaryProps) => {
  const { data: pDetail = null } = getPersonal();
  const personalData = pDetail?.personalDetailSection?.personalDetails ?? null;
  useEffect(() => {
    const parent = document.getElementById("scroller");
    let showIndex = 0;
    const intervalId = setInterval(() => {
      if (showIndex >= animateText.length) {
        showIndex = 0;
      }
      const child = document.createElement("p");
      child.innerHTML = animateText[showIndex];
      if (parent) {
        parent.innerHTML = "";
        parent.appendChild(child);
      }
      showIndex++;
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <div
      className={`bg-grey-01 absolute left-0 top-0 z-10 flex h-full w-full flex-col items-center justify-center ${isStartToFade ? "animate-fadeIn" : ""}`}
    >
      <p className="text-grey-10">Hi {personalData?.fullName ?? "Seeker"},</p>
      <div
        id="scroller"
        className="w-1/2 text-center text-[32px] font-bold text-white"
      >
        <p>Sending details to AI</p>
      </div>
    </div>
  );
};

export default LoadingSummary;
